// extracted by mini-css-extract-plugin
export default {"absolute":"Confirmation_absolute__c22NA","confirmation":"Confirmation_confirmation__ncE2j","textBlock":"Confirmation_textBlock__C3fvb","buttons":"Confirmation_buttons__b8VeH"};